import { make } from 'vuex-pathify';
import { debounce } from 'throttle-debounce';
import state from './state';
import client from '@/api';

export default {
    ...make.actions(state),

    async loadDocument({ dispatch, getters }) {
        const response = await client.execute('get', `documents/${getters.documentId}?event_id=${getters.eventId}`);

        dispatch('setDocument', response);
    },

    async saveDocument({ getters }) {
        await client.execute('put', `documents/${getters.documentId}`, getters.document);
    },

    async saveSection({ dispatch, getters }) {
        await dispatch(
            getters.section.id ? 'updateSection' : 'createSection',
            getters.section
        );
    },

    async createSection({ dispatch, getters }, section) {
        await client.execute('post', 'document_sections', {
            document_id: getters.documentId,
            ...section,
        });

        await dispatch('loadDocument');
    },

    async updateSection({ dispatch }, section) {
        await client.execute('put', `document_sections/${section.id}`, section);

        dispatch('loadDocument');
    },

    async updateSectionsOrder({ dispatch }, sections) {
        await client.execute('post', 'document_sections/order', {
            sections,
        });

        await dispatch('loadDocument');

        dispatch('setDragging', false);
    },

    async deleteSection({ dispatch }, section) {
        await client.execute('delete', `document_sections/${section.id}`);

        dispatch('loadDocument');
    },

    async saveField({ dispatch, getters }) {
        await dispatch(
            getters.field.id ? 'updateField' : 'createField',
            { field: getters.field }
        );
    },

    async createField({ dispatch }, { field }) {
        await client.execute('post', 'document_fields', field);

        dispatch('loadDocument');
    },

    async updateField({ dispatch }, { field, reload = true }) {
        await client.execute('patch', `document_fields/${field.id}`, field);

        if (reload) {
            dispatch('loadDocument');
        }
    },

    updateFieldDebounced: debounce(500, async ({ dispatch, getters }, fieldId) => {
        dispatch('updateField', { field: getters.fieldById(fieldId), reload: false });
    }),

    async updateFieldsOrder({ dispatch }, fields) {
        await client.execute('post', 'document_fields/order', {
            fields,
        });

        await dispatch('loadDocument');
    },

    async deleteField({ dispatch }, field) {
        await client.execute('delete', `document_fields/${field.id}`);

        dispatch('loadDocument');
    },

    async updateTableColumn({ commit, dispatch }, { field, rowIndex, column, value }) {
        await commit('UPDATE_TABLE_COLUMN', { field, rowIndex, column, value });
        await dispatch('updateFieldDebounced', field.id);
    },

};
